(function() {

    'use strict';
    /* Register or Manage Credit Card Controller - START*/
    angular.module('eclipseApp.myAccount').controller('registerCreditCardConfirmCtrl', ['$scope', '$filter', '$rootScope', 'manageCreditCardService', 'httpService', 'prepaidUserInfoService', 'prepaidRegisteredCCInfoService', '$stateParams', 'uteSemafoneService', 'util', function($scope,$filter, $rootScope, manageCreditCardService, httpService, prepaidUserInfoService, prepaidRegisteredCCInfoService, $stateParams, uteSemafoneService, util) {

        console.log('Register Credit Card Confirmation Page');
        $scope.$extend({
            showRegister:false,
            showManage:false,
            showError:false,
            showCardDetails:false,
            cardExpiryMonth: prepaidRegisteredCCInfoService.getMonth(),
            cardExpiryYear: prepaidRegisteredCCInfoService.getYear(),
            creditCardNumber: prepaidRegisteredCCInfoService.getMaskedCCNumber(),
            ccNum:$filter('maskCCNumber')(prepaidRegisteredCCInfoService.getTokenizedCCNumber()),
            userFname: prepaidUserInfoService.getFirstName(),
            userLname: prepaidUserInfoService.getLastName(),
            registerFlag: prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus(),
            ccStat: manageCreditCardService.getCardStatus(),
            creditCardFlowIndicator: manageCreditCardService.getCreditCardFlowIndicator(),
            ccStatus: manageCreditCardService.getCardStatus()
        });

        if ($scope.registerFlag == true) {
            $scope.showRegister = false;
            $scope.showManage = true;
        } else if ($scope.registerFlag == false) {
            $scope.showRegister = true;
            $scope.showManage = false;
        } else {
            $scope.showError = true;
            $scope.showCardDetails = false;
        }
        $scope.formattedDate= new Date($scope.cardExpiryMonth);


    }]);
    /* Register or Manage Credit Card Controller - END*/
})();